import {
    ChatMessageModel,
    ChatModel,
    MessageModel,
    OpenFireChatType,
    OperatorType,
    LoginResponse,
    XmppSessionType,
    MessageType,
    XmppSessionTypes,
    TestingChatModule,
} from "../models";
import { IChatService } from "./IChatService";
import EventEmitter, { Events } from "./eventemitter";
import moment from "moment";
import { signalRChatService } from "./SignalRChatService";
import { AvailableUserForTransfer, UserData, IDestroyRoom } from "../models/index";
import { Strophe, $pres } from "strophe.js";
import { ConnectionStatus } from "../models/connectionStatus";
import { chatService } from "./chatService";
import { logger } from "./Logger";
// import { broadcastChannelService, BroadcastEvents } from "./BroadcastChannelService";
import { fireBaseService } from "./FireBaseService";
import { utils } from "../utils";
import { LocalStorageService } from "./localStorageService";
import { DetectEnvironment } from "../EnvironmentSettings";
import { sessionStorageService } from "./SessionStorageService";
import { cookieService } from "./CookieService";
import { notificationService } from "./PushNotificationService";
import { t } from "i18next";
import { wglcsApiService } from "./WglcsApiService";

interface XmppPacket {
    to: string;
    chat_id: string;
    custom_packet: string;
    user_id: string;
    manager_id: string;
    time_stamp: string;
    visitor_name: string;
    website_id: string;
    type: string;
    messageType: string;
    message: string;
    end_time?: string;
}

enum XmppChatStatus {
    Online,
    Away,
}

Strophe.setLogLevel(Strophe.LogLevel.ERROR as any);

class XmppChatService implements IChatService {
    public stropheConnection: Strophe.Connection = null!;
    public isStrophDisconnected = true;
    connectingState = false;
    firebaseToken = "";
    randomNo: string = "";
    isAttaching: boolean = false;
    isSending : boolean = false;
    handlersAttached: boolean = false;
    messageForNotification: string = "";

    constructor() {
        if (utils.isThisMobileDevice()) {
            this.initEventListeners();
        }
        this.addNetworkListeners();
        // broadcastChannelService.on(BroadcastEvents.RequestStropheStatus, this.onRequestStropheStatus);
    }

    initEventListeners() {
        window.addEventListener("blur", this.handleBlur);
        window.addEventListener("focus", this.handleFocus);
    }

    handleBlur() {
        var state = XmppChatStatus.Away;
        xmppChatService.sendPresence(state);
    }

    handleFocus() {
        var state = XmppChatStatus.Online;
        xmppChatService.sendPresence(state);
    }

    connect = async (type: XmppSessionType) => {
        if (chatService.AutoReconnect == false) {
            return;
        }

        var userData = this.GetUserLoginData();

        if (userData === null) {
            setTimeout(() => this.connect(type), 5000);
            return;
        }

        if (!this.connectingState) {
            this.connectingState = true;
            this.stropheConnection = await this.connectStrophe(type);
            this.attachEvents();
        }
    };

    private GetUserLoginData(): UserData | null {
        var userData = JSON.parse(localStorage.getItem("USER_DATA")!) as LoginResponse;

        if (userData === null) {
            return null;
        }

        return userData.userLoginData;
    }

    // isStropheDisconnected = () => {
    //     return this.stropheConnection === null || (this.stropheConnection as any)?.connected === false;
    // };

    onRequestStropheStatus = () => {
        if (this.isConnected()) {
            sessionStorageService.setItem("OpenFireConnectionStatus", "Connected");

            // broadcastChannelService.send(BroadcastEvents.onStropheStatusChanged, ConnectionStatus.Connected);
        }
    };

    isConnected = () => {
        return this.stropheConnection != null && (this.stropheConnection as any)?.connected == true;
    };

    isStropheDisconnecting = () => {
        return (this.stropheConnection as any)?.disconnecting;
    };

    isStropheDisconnected = () => {
        return this.isStrophDisconnected;
    };

    isStropheConnected = () => {
        return (this.stropheConnection as any)?.connected;
    };

    addNetworkListeners() {
        window.addEventListener("online", () => {
            sessionStorageService.setItem("OpenFireConnectionStatus", "Connected");
            EventEmitter.emit(Events.strophConnectionStatus, "Connected");
        });

        window.addEventListener("offline", () => {
            sessionStorageService.setItem("OpenFireConnectionStatus", "DISCONNECTED");
            EventEmitter.emit(Events.strophConnectionStatus, "Disconnected");
        });
    }

    connectStrophe = (type: XmppSessionType): Promise<Strophe.Connection> => {
        return new Promise<Strophe.Connection>((resolve: (connection: Strophe.Connection) => void) => {
            var xmppconnection = new Strophe.Connection(process.env.REACT_APP_XMPP_URL!, {
                mechanisms: [Strophe.SASLPlain],
            } as any);

            var userData = this.GetUserLoginData();

            if (utils.isLoggedInResourcesScreenActive()) {
                this.randomNo = utils.GenerateRandomCode()?.toString();
                this.firebaseToken = XmppSessionTypes.LiveAdminsManagerial + this.randomNo;
            } else if (utils.isMonitoringPanelScreenActive()) {
                this.firebaseToken = XmppSessionTypes.LiveAdmins6er;
            } else {
                this.firebaseToken = fireBaseService.CurrentToken;
                if (utils.detectMobileDevice()) {
                    var token = cookieService.getElectronCookies("firebase_token");
                    this.firebaseToken = token;
                    // alert("Firebase Token :" + token)
                }

                if (this.firebaseToken == null || this.firebaseToken == "") {
                    if (utils.isLiveAdminsCompany(userData?.empCompId as any)) {
                        this.firebaseToken = XmppSessionTypes.LiveAdminsChat;
                    } else {
                        this.firebaseToken = XmppSessionTypes.DepLiveChat;
                    }
                }

                // var token = localStorage.getItem("fireBaseToken")
                if (this.firebaseToken != null && this.firebaseToken != undefined) {
                    this.firebaseToken = this.firebaseToken;
                } else {
                    this.randomNo = utils.GenerateRandomCode()?.toString();
                    this.firebaseToken = this.randomNo;
                }
            }

            if (utils.isElectronBuild() && utils.isOperaterScreenActive()) {
                let token = localStorage.getItem("fireBaseToken");

                if (token != null && token != "undefined") {
                    this.firebaseToken = token;
                }
            }
            xmppconnection.connect(
                // userData!.userId + `@localhost/LiveAdmins${typeStr}`,
                userData!.userId + `@localhost/${this.firebaseToken}`,

                userData!.userPassword,
                (status: Strophe.Status, reason: string) => {
                    if (status === Strophe.Status.CONNECTING) {
                        this.isStrophDisconnected = false;
                        sessionStorageService.setItem("OpenFireConnectionStatus", "CONNECTING");
                        EventEmitter.emit(Events.strophConnectionStatus, "");
                        logger.log("Strophe Status: CONNECTING");
                    } else if (status === Strophe.Status.AUTHENTICATING) {
                        logger.log("Strophe Status: AUTHENTICATING");
                    } else if (status === Strophe.Status.CONNECTED) {
                        this.isStrophDisconnected = false;

                        logger.log("Strophe Status: Connected.");
                        sessionStorageService.setItem("OpenFireConnectionStatus", "Connected");
                        EventEmitter.emit(Events.strophConnectionStatus, "");
                        resolve(xmppconnection as any);
                    } else if (status === Strophe.Status.CONNFAIL) {
                        this.connectingState = false;
                    } else if (status === Strophe.Status.DISCONNECTING) {
                        this.isStrophDisconnected = false;

                        logger.log("Strophe Status: Disconnecting");
                    } else if (status === Strophe.Status.DISCONNECTED) {
                        sessionStorageService.setItem("OpenFireConnectionStatus", "DISCONNECTED");
                        EventEmitter.emit(Events.strophConnectionStatus, "");

                        logger.log(`Strophe Status: Disconnected. Reason: ${reason}`);

                        this.connectingState = false;
                        this.isStrophDisconnected = true;

                        if (reason === "conflict") {
                            this.checkBeforeAlert()

                            this.connectingState = false;
                        } else {
                            this.connectingState = false;
                            setTimeout(() => {
                                this.connect(type);
                            }, 5000);
                        }
                    } else if (status === Strophe.Status.AUTHFAIL) {
                        this.connectingState = false;
                        logger.log(`AUTHFAIL with error: ${reason}`);
                    } else if (status === Strophe.Status.ERROR) {
                        this.connectingState = false;
                        logger.log(`ERROR with error: ${reason}`);
                    } else {
                        logger.log(`refused`);
                    }
                },
                undefined,
                undefined,
                "xmpp:localhost:5225"
            );
        });
    };

    checkBeforeAlert = async () => {
        const userData = this.GetUserLoginData()
        let logIdResult = await wglcsApiService.getIsLogIDAlive(userData?.userLog!);
        if (logIdResult?.data != null && logIdResult?.success && logIdResult.message != "Network Error") {

            var loggedIntime = localStorage.getItem("loggedinTime");
            if (loggedIntime != null && loggedIntime != undefined) {
                if (logIdResult?.data as any != false) {
                    var myDate_ = new Date(loggedIntime);
                    var differenceInSeconds = utils.getTimeDifference(myDate_, new Date());
                    if (differenceInSeconds > 18) {
                        EventEmitter.emit(Events.sessionExpired, t("Session.message"));
                    }
                }
            }
        }
    }

    onMessageEvent = (msg) => {
        if (this.isDestroyRoom(msg)) {
            // No Need to do anything here.
        }
        else {
            var val = this.extractMessageFromInvite(msg);
            if (val !== null) {
                signalRChatService.attachEvents(val.chatId, val.websiteId, val.visitorId);
                // signalRChatService.invitationAcknowledge(val.visitorId, val.chatId);
                EventEmitter.emit(Events.onNewChatReceived, val);
            }
        }
        return true;
    };

    onGroupChatMessageEvent = (msg) => {
        if (this.isDestroyRoom(msg)) {
            // No Need to do anything here.
        } else {
            var obj = this.extractMessageFromGroupChat(msg);
            if (utils.isTestingScreenActive()) {
                EventEmitter.emit(Events.onTestingMessageReceived, obj);
            } else {
                EventEmitter.emit(Events.onChatMessageReceived, obj);
            }
        }
        return true;
    };

    attachEvents = () => {
        if (this.isAttaching) return; 
        this.isAttaching = true;
    
        if (this.isStropheDisconnecting() || !this.isConnected()) {
            setTimeout(() => {
                this.isAttaching = false;
                this.attachEvents();
            }, 3000);
            return;
        }
        this.stropheConnection.send($pres());
        if (document.visibilityState == "visible") {
            this.sendPresence(XmppChatStatus.Online);
        } else {
            this.sendPresence(XmppChatStatus.Away);
        }
    
        if (!this.handlersAttached) {
            (this.stropheConnection as any).addHandler(() => {
                return true;
            }, "jabber:x:conference");
    
            (this.stropheConnection as any).addHandler(this.onMessageEvent, null, "message", null, null, null);
            (this.stropheConnection as any).addHandler(this.onGroupChatMessageEvent, null, "message", "groupchat");
    
            this.handlersAttached = true;
        }
        EventEmitter.emit(Events.ReAttachExistingRooms, null);
        this.isAttaching = false; 
    };

    removeEvents = () => { };

    isDestroyRoom(msg: Element): boolean {
        let bodyMessage = Strophe.getText(msg.getElementsByTagName("body")[0]);

        if (bodyMessage === "[destroy room]" || bodyMessage === "[DND]") {
            let chatId = msg.getAttribute("chat_id");
            if (utils.isTestingScreenActive()) {
                EventEmitter.emit(Events.OnTestingDestroyRoom, chatId);
            }else if(utils.isMonitoringPanelScreenActive()){
                EventEmitter.emit(Events.DNDClosedChat, chatId);
            }
            else {
                EventEmitter.emit(Events.OnDestroyRoom, {
                    chatId: chatId,
                    showMailForm: true,
                } as IDestroyRoom);
            }
            EventEmitter.emit(Events.closeLoggedInChatWindow);

            return true;
        }
        return false;
    }
    extractMessageFromInvite = (msg: Element): MessageModel | null => {
        var from = msg.getAttribute("from");
        var invite = msg.getElementsByTagName("invite");
        var reason = msg.getElementsByTagName("reason");
        if (invite[0]) {
            logger.log(`xmpp extractMessageFromInvite Got Invitaion for: ${reason[0].innerHTML}`);
            this.reAttachExistingRoom({ roomId: from } as ChatModel);
            return this.extractMessage(reason[0].innerHTML);
        }

        return null;
    };

    extractMessageFromGroupChat = (msg: Element): ChatMessageModel => {
        var from = msg.getAttribute("from") ?? "";
        var userId = msg.getAttribute("user_id") ?? "";
        var manager_id = msg.getAttribute("manager_id") ?? "";
        var visitorName = msg.getAttribute("visitor_name") ?? "";
        const currentUtcTime = moment.utc().format("YYYY/MM/DD HH:mm:ss:SSSS");
        let timeStamp = currentUtcTime;

        var elems = msg.getElementsByTagName("body");
        let _msg = Strophe.getText(elems[0]);
        let message = _msg?.replace(/&apos;/g, "'")?.replace(/&quot;/g, '"');

        var messageType = msg.getAttribute("messageType") ?? "";
        var website_id = msg.getAttribute("website_id") ?? "";
        // Optional Parameters
        // var to = msg.getAttribute('to');
        // var websiteId = msg.getAttribute('website_id');
        // var endTime = msg.getAttribute('end_time');
        // var invite = msg.getElementsByTagName('invite');
        let chatId = msg.getAttribute("chat_id");
        var userData = this.GetUserLoginData()!;

        if (message?.includes("[TRANSFERCHAT]_Transferred By")) {
            this.messageForNotification = message;
        }

        if (userId?.toString() == userData?.userId?.toString() && msg?.innerHTML?.includes('<gone xmlns="http://jabber.org/protocol/chatstates"/>')) {
            if (utils.isOperaterScreenActive()) {
                notificationService.showNotification("", this.messageForNotification);
            }

            EventEmitter.emit(Events.OnDestroyRoom, {
                chatId: chatId,
                showMailForm: false,
            } as IDestroyRoom);

            this.leaveRoom(chatId!);
        }

        from = this.getRoom(msg.getAttribute("from")) ?? "";
        if (msg.innerHTML != "" && msg.innerHTML != undefined && msg.innerHTML?.startsWith("<active") && msg.innerHTML?.includes("chatstates")) {
            messageType = MessageType.BuzzChat?.toString();
        }

        var _timeStamp = "";
        if (msg.innerHTML != "" && msg.innerHTML != undefined && msg.innerHTML?.includes("delay") && msg.innerHTML?.includes("stamp=")) {
            const startIndex = msg.innerHTML.indexOf('stamp="');
            const endIndex = msg.innerHTML.indexOf('from="');
            const stampValue = msg.innerHTML?.substring(startIndex + 7, endIndex - 2);

            const convertedTime2 = moment.utc(stampValue).format("YYYY/MM/DD HH:mm:ss:SSSS");
            timeStamp = convertedTime2;

            var timeDifference = LocalStorageService.getLocalStorage("timeDifference");
            if (timeDifference?.toString()?.includes("-")) {
                let time = timeDifference?.toString()?.split("-");
                const addedTime = moment(timeStamp, "YYYY/MM/DD HH:mm:ss:SSSS").add(time[1], "seconds").format("YYYY/MM/DD HH:mm:ss:SSSS");
                timeStamp = addedTime;
            } else {
                const substractedTime = moment(timeStamp, "YYYY/MM/DD HH:mm:ss:SSSS")
                    .subtract(parseInt(timeDifference), "seconds")
                    .format("YYYY/MM/DD HH:mm:ss:SSSS");
                timeStamp = substractedTime;
            }
        }

        var _chatId;
        if (from?.toString().includes("room")) {
            _chatId = from.substring(from.lastIndexOf("m") + 1, from.lastIndexOf("@"));
        } else {
            _chatId = chatId;
        }

        return new ChatMessageModel(
            _chatId,
            userId,
            visitorName,
            message,
            timeStamp,
            from,
            "Strophe",
            manager_id,
            visitorName,
            parseInt(messageType),
            website_id,
            ""
        );
    };

    getRoom = (_room) => {
        var roomId = _room;
        var n = roomId.indexOf("/");
        if (parseInt(n) === -1) {
            return roomId;
        } else {
            var room = roomId.substring(0, n);
            return room;
        }
    };

    sendMessage = (chat: ChatModel, messageBody: string, takenOver: boolean, userId: string, messageType: MessageType, chatSize: number, TextToSpeech?: boolean) => {
        if (this.isSending) return;
        this.isSending = true;
    
        setTimeout(() => { 
            this.isSending = false;
        }, 100);  

        var roomId = chat.roomId;
        var website_id = chat.info.websiteId;
        var chatId = chat.info.chatId;

        var userData = this.GetUserLoginData()!;
        var _managerId = userData.userId;
        var userId = userId
        if (messageType == MessageType.AutoQCMessage) {
            _managerId = 3551;
            userId = "-3551"
        }

        var visitorName_ = userData.username
        if (!takenOver) {
            if (utils.isQcMasterPanelActive()) {
                visitorName_ = "MasterQC"
            }
            else if (chat.operatorType === OperatorType.QualityControl) {
                visitorName_ = "QC"
            }
            else if (messageType == MessageType.AutoQCMessage) {
                visitorName_ = `QC${chatSize}`
            }
        }

        var o: XmppPacket = {
            to: roomId,
            type: "groupchat",
            chat_id: chatId,
            custom_packet: true.toString(),
            message: messageBody,
            user_id: userId.toString(),
            manager_id: _managerId.toString(),
            time_stamp: moment().format("YYYY-MM-DD HH:mm:ss"),
            website_id: website_id,
            visitor_name: chat.pseudoName ? chat.pseudoName : visitorName_,
            messageType: messageType?.toString(),
        };

        var m = $msg(o as any);
        m.c("body", undefined, messageBody);
        this.stropheConnection.send(m.tree());
    };

    sendMessageToOperater = (chat: TestingChatModule, messageBody: string) => {
        var roomId = chat.roomId;
        var website_id = chat.info.websiteId;
        var chatId = chat.info.chatId;

        var o: XmppPacket = {
            to: roomId,
            type: "groupchat",
            chat_id: chatId,
            custom_packet: true.toString(),
            message: messageBody,
            user_id: "0",
            manager_id: "0",
            time_stamp: "",
            website_id: website_id,
            visitor_name: chat.info.visitorName,
        } as any;
        var m = $msg(o as any);
        m.c("body", undefined, messageBody);
        this.stropheConnection.send(m.tree());
    };

    SendInvitationMessage = (chat: TestingChatModule) => {
        var invite_packet =
            chat.info.chatId + "|" + chat.info.websiteId + "|" + chat.info.visitorId + "|" + chat.info.visitorName + "|" + chat.info.userId + "|";

        this.stropheConnection.send(
            $msg({
                to: "room" + chat.info.chatId + XmppSessionTypes.localhost,
            })
                .c("x", {
                    xmlns: "http://jabber.org/protocol/muc#user",
                })
                .c("invite", {
                    // to: targetOperator.userId + "@localhost/"+ XmppSessionTypes.LiveAdminsChat,
                    to: chat.info.userId + `@localhost`,
                })
                .c("reason")
                .t(invite_packet.toString())
        );
    };

    private extractMessage = (invite): MessageModel => {
        let str = invite;
        let oneIndex = str.indexOf("|");
        let chatId = str.substring(0, oneIndex);

        str = str.substring(oneIndex + 1, str.length);
        oneIndex = str.indexOf("|");
        let websiteId = str.substring(0, oneIndex);

        str = str.substring(oneIndex + 1, str.length);
        oneIndex = str.indexOf("|");
        let visitorId = str.substring(0, oneIndex);

        str = str.substring(oneIndex + 1, str.length);
        oneIndex = str.indexOf("|");
        let visitorName = str.substring(0, oneIndex);

        str = str.substring(oneIndex + 1, str.length);
        oneIndex = str.indexOf("|");
        let VisitorJID = str.substring(0, oneIndex);

        str = str.substring(oneIndex + 1, str.length);
        oneIndex = str.indexOf("|");
        let autoGreetMessage = str.substring(0, oneIndex);

        let userName = str.substring(oneIndex + 1, str.length);

        var userData = JSON.parse(localStorage.getItem("USER_DATA")!) as LoginResponse;
        EventEmitter.emit(Events.chatInviteLog, {data: invite + "|" + userData.userLoginData.userId.toString(), chatId});

        //....this code will help to differentiate claim chat
        const existingChat = JSON.parse(localStorage.getItem("chatTree")!) || ([] as any);
        var flag = true;
        if (existingChat?.length > 0 && existingChat != null) {
            flag = existingChat.some((x) => x != chatId);
        }

        if (!VisitorJID?.includes("@localhost/") && !utils.isLiveAdminsCompany(userData?.userLoginData?.empCompId) && flag) {
            existingChat.push(chatId);
            localStorage.setItem("chatTree", JSON.stringify(existingChat));
        }

        return {
            chatId: chatId,
            websiteId: websiteId,
            visitorId: visitorId,
            visitorName: visitorName,
            VisitorJID: VisitorJID,
            autoGreetMessage: autoGreetMessage,
            userName: userName,
            chatType: OpenFireChatType,
            userId: "",
        };
    };

    transferChat = async (chatInfo: MessageModel, targetOperator: AvailableUserForTransfer, isAutoTransfer: boolean) => {
        if (chatInfo.VisitorJID === "" || chatInfo.autoGreetMessage === "") {
            var reason_packet =
                chatInfo.chatId + "|" + chatInfo.websiteId + "|" + chatInfo.visitorId + "|" + chatInfo.visitorName + "|" + chatInfo.userName;
        } else {
            reason_packet =
                chatInfo.chatId +
                "|" +
                chatInfo.websiteId +
                "|" +
                chatInfo.visitorId +
                "|" +
                chatInfo.visitorName +
                "|" +
                chatInfo.autoGreetMessage +
                "|" +
                chatInfo.userName;
        }

        this.stropheConnection.send(
            $msg({
                to: "room" + chatInfo.chatId + XmppSessionTypes.localhost,
            })
                .c("x", {
                    xmlns: "http://jabber.org/protocol/muc#user",
                })
                .c("invite", {
                    // to: targetOperator.userId + "@localhost/"+ XmppSessionTypes.LiveAdminsChat,
                    to: targetOperator.userId + `@localhost`,
                })
                .c("reason")
                .t(reason_packet.toString())
        );

        var userData = this.GetUserLoginData()!;

        var o: XmppPacket = {
            to: "room" + chatInfo.chatId + XmppSessionTypes.localhost,
            type: "groupchat",
            message: "",
            chat_id: chatInfo.chatId,
            custom_packet: true.toString(),
            user_id: "-" + targetOperator.userId,
            manager_id: targetOperator.userId.toString(),
            time_stamp: moment().format("YYYY-MM-DD HH:mm:ss"),
            website_id: chatInfo.websiteId,
            visitor_name: targetOperator.userName,
            messageType: MessageType.TransferChat.toString(),
        };

        let tMessage = `[TRANSFERCHAT]_Transferred By ${userData.username} to ${targetOperator.userName}`;
        if (isAutoTransfer) tMessage = `[AutoTransfer]_Transferred By ${userData.username} to ${targetOperator.userName}`;

        var m = $msg(o as any);
        m.c("body", undefined, tMessage);

        this.stropheConnection.send(m.tree());
        notificationService.showNotification("TransferChat", tMessage);

        // //..........................qc message
        // var o: XmppPacket = {
        //     to: "room" + chatInfo.chatId + XmppSessionTypes.localhost,
        //     type: "groupchat",
        //     message: '[AutoTransfer] transfering chat to backup agents',
        //     chat_id: chatInfo.chatId,
        //     custom_packet: true,
        //     user_id: "-" + userData.userId,
        //     manager_id: targetOperator.userId,
        //     time_stamp: moment.utc().format("YYYY-MM-DD HH:mm:ss"),
        //     website_id: chatInfo.websiteId,
        //     visitor_name: targetOperator.userName,
        //     messageType: MessageType.TransferChat,
        // };

        // let qcMessage ='[AutoTransfer] transfering chat to backup agents'
        // var m = $msg(o as any);
        // m.c("body", undefined, tMessage);

        // await this.stropheConnection.send(m.tree());

        // var packet: XmppPacket = {
        //     // to: "room" + chatInfo.chatId + XmppSessionTypes.localhost +"/"+ XmppSessionTypes.LiveAdminsChat,
        //     to: "room" + chatInfo.chatId + XmppSessionTypes.localhost,
        //     message: "",
        //     chat_id: chatInfo.chatId,
        //     custom_packet: !1,
        //     user_id: userData.userId.toString(),
        //     manager_id: userData.userId,
        //     time_stamp: "2020-10-12 15:10:59",
        //     visitor_name: "System",
        //     website_id: chatInfo.websiteId,
        //     type: "groupchat",
        //     messageType: MessageType.TransferChat,
        // };

        // await this.stropheConnection.send(
        //     $msg(packet).c("gone", {
        //         xmlns: "http://jabber.org/protocol/chatstates",
        //     })
        // );

        var obj = {
            // to: "room" + chatInfo.chatId + XmppSessionTypes.localhost +"/"+ XmppSessionTypes.LiveAdminsChat,
            to: "room" + chatInfo.chatId + XmppSessionTypes.localhost,
            type: "unavailable",
            //leave room.
            from: userData.userId + "@localhost",
        };
        var tdata = $pres(obj);
        (tdata as any).c("x", { xmlns: "http://jabber.org/protocol/muc#user" }, null);

        this.stropheConnection.send(tdata.tree());
    };

    transferChatByQc = async (
        chatInfo: MessageModel,
        targetOperator: AvailableUserForTransfer,
        isAutoTransfer: boolean,
        chatType: string,
        domainName: string
    ) => {
        var userData = this.GetUserLoginData()!;

        var reason_packet =
            chatInfo.chatId +
            "|" +
            chatInfo.websiteId +
            "|" +
            chatInfo.visitorId +
            "|" +
            chatInfo.visitorName +
            "|" +
            chatInfo.autoGreetMessage +
            "|" +
            chatInfo.userName;

        this.stropheConnection.send(
            $msg({
                to: "room" + chatInfo.chatId + XmppSessionTypes.localhost,
            })
                .c("x", {
                    xmlns: "http://jabber.org/protocol/muc#user",
                })
                .c("invite", {
                    // to: targetOperator.userId + "@localhost/"+ XmppSessionTypes.LiveAdminsChat,
                    to: targetOperator.userId + `@localhost`,
                })
                .c("reason")
                .t(reason_packet.toString())
        );

        var userData = this.GetUserLoginData()!;

        var tMessage = `[TRANSFERCHAT]_Transferred By ${userData.username} to ${targetOperator.userName}`;

        var index = targetOperator.userName.indexOf("(");
        var targerUserName = targetOperator.userName?.substring(0, index);

        setTimeout(() => {
            var o: XmppPacket = {
                to: "room" + chatInfo.chatId + XmppSessionTypes.localhost,
                type: "groupchat",
                message: "",
                chat_id: chatInfo.chatId,
                custom_packet: true.toString(),
                user_id: "-" + targetOperator.userId,
                manager_id: targetOperator.userId.toString(),
                time_stamp: moment().format("YYYY-MM-DD HH:mm:ss"),
                website_id: chatInfo.websiteId,
                visitor_name: targetOperator.userName,
                messageType: MessageType.TransferChat?.toString(),
            };
            var m = $msg(o as any);
            m.c("body", undefined, tMessage);
            this.stropheConnection.send(m.tree());

            // var obj = {
            //     // to: "room" + chatInfo.chatId + XmppSessionTypes.localhost +"/"+ XmppSessionTypes.LiveAdminsChat,
            //     to: "room" + chatInfo.chatId + XmppSessionTypes.localhost,
            //     type: "unavailable",
            //     //leave room.
            //     from: chatInfo.userId + "@localhost",
            // };
            // var tdata = $pres(obj);
            // (tdata as any).c("x", { xmlns: "http://jabber.org/protocol/muc#user" }, null);
            // this.stropheConnection.send(tdata.tree());

            var packet: any = {
                to: "room" + chatInfo.chatId + XmppSessionTypes.localhost,
                chat_id: chatInfo.chatId,
                custom_packet: false.toString(),
                user_id: chatInfo.userId.toString(),
                manager_id: parseInt(chatInfo.userId).toString(),
                time_stamp: moment().format("YYYY-MM-DD HH:mm:ss"),
                visitor_name: "System",
                website_id: "0",
                type: "groupchat",
                messageType: MessageType.TransferChat?.toString(),
            };

            this.stropheConnection.send(
                $msg(packet).c("gone", {
                    xmlns: "http://jabber.org/protocol/chatstates",
                })
            );
        }, 300);
    };
    leaveRoom = (chatId: string) => {
        var userData = this.GetUserLoginData()!;

        var obj = {
            to: "room" + chatId + XmppSessionTypes.localhost,
            type: "unavailable",
            from: userData.userId + "@localhost",
        };
        var tdata = $pres(obj);
        (tdata as any).c("x", { xmlns: "http://jabber.org/protocol/muc#user" }, null);

        this.stropheConnection.send(tdata.tree());
    };

    reAttachExistingRoom = (item: ChatModel) => {
        var userData = this.GetUserLoginData()!;

        var o = { to: item.roomId + "/" + userData.username };

        var m: Strophe.Builder = $pres(o);

        m.c("x", { xmlns: "muc#roomconfig_changesubject" }, null!); //'http://jabber.org/protocol/muc#user'

        this.stropheConnection.send(m.tree());
    };

    reJoinExistingRoom = (chatId: string) => {
        var userData = this.GetUserLoginData()!;

        var roomId = "room" + chatId + XmppSessionTypes.localhost;
        var o = { to: roomId + "/" + userData.username };

        var m: Strophe.Builder = $pres(o);

        m.c("x", { xmlns: "muc#roomconfig_changesubject" }, null!); //'http://jabber.org/protocol/muc#user'

        this.stropheConnection.send(m.tree());
    };

    disconnect = async () => {
        if (!this.isConnected()) {
            // console.error("Strophe Connection already disconnected. Cannot disconnect");
            return;
        }

        var userData = this.GetUserLoginData();

        if (userData == null) {
            return;
        }

        var obj = {
            type: "unavailable",
            from: userData.userId + "@localhost/" + XmppSessionTypes.LiveAdminsChat,
        };

        var tdata = $pres(obj);
        (tdata as any).c("x", { xmlns: "http://jabber.org/protocol/muc#user" }, null);
        await this.stropheConnection.send(tdata.tree());
        await this.stropheConnection.flush();
        await this.stropheConnection.disconnect("custom reason");
    };

    dndChat = async (chatType: string, roomId: string, websiteId: string, visitorId: string, chatId: string) => {
        var userData = this.GetUserLoginData()!;
        var o: XmppPacket = {
            to: roomId,
            type: "groupchat",
            website_id: websiteId.toString(),
            time_stamp: moment().format("YYYY-MM-DD HH:mm:ss"),
            end_time: true,
            message: "",
            messageType: MessageType.Other?.toString(),
            chat_id: chatId,
            custom_packet: true.toString(),
            user_id: userData.userId.toString(),
            manager_id: userData.userId.toString(),
            visitor_name: userData.username,
        } as any;

        var m = $msg(o as any);
        m.c("body", undefined, "[DND]");
        this.stropheConnection.send(m.tree());
    };

    blockChat = async (chatType: string, roomId: string, websiteId: string, visitorId: string, chat_id: string) => {
        // TODO. Fix async arrow assignment
        var userData = this.GetUserLoginData()!;
        var o: XmppPacket = {
            to: roomId,
            chat_id: chat_id,
            visitorId: visitorId,
            user_id: "-" + userData.userId,
            manager_id: userData.userId.toString(),
            type: "groupchat",
            end_time: true,
            custom_packet: true.toString(),
        } as any;

        var m = $msg(o as any);
        m.c("body", undefined, "[Ignore]");
        this.stropheConnection.send(m.tree());
    };

    QCMessageByCannedKeyword = async (
        message: string,
        chatType: string,
        roomId: string,
        websiteId: string,
        visitorId: string,
        chat_id: string,
        VisitorName: string
    ) => {
        // TODO. Fix async arrow assignment
        var userData = this.GetUserLoginData()!;
        var o: XmppPacket = {
            to: roomId,
            chatId: chat_id,
            chatType: chatType,
            visitorId: visitorId,
            user_id: "-" + userData.userId,
            manager_id: userData.userId.toString(),
            time_stamp: moment().format("YYYY-MM-DD HH:mm:ss"),
            type: "groupchat",
            custom_packet: true.toString(),
            visitor_name: VisitorName,
        } as any;

        var m = $msg(o as any);
        m.c("body", undefined, message);
        this.stropheConnection.send(m.tree());
    };

    ChangeNickNameRequest(chatId: string) {
        var userData = this.GetUserLoginData()!;

        // TODO. Fix async arrow assignment
        var o: any = {
            to: "room" + chatId + XmppSessionTypes.localhost,
            newNickName: userData.userId.toString(),
        };
        var m = $msg(o as any);
        m.c("body", undefined, "ChangeNickNameRequest");

        this.stropheConnection.send(m.tree());
    }

    updateNickName(chatType: string, chatId: string, websiteId: Number, visitorId: string, visitorName: string) {
        var userData = this.GetUserLoginData()!;

        // TODO. Fix async arrow assignment
        var o: XmppPacket = {
            to: "room" + chatId + XmppSessionTypes.localhost,
            type: "groupchat",
            chat_id: chatId,
            custom_packet: true.toString(),
            user_id: userData.userId.toString(),
            manager_id: userData.userId.toString(),
            time_stamp: moment().format("YYYY-MM-DD HH:mm:ss"),
            website_id: websiteId.toString(),
            visitor_name: visitorName,
            message: "",
            messageType: MessageType.Other?.toString(),
        };
        var m = $msg(o as any);
        m.c("body", undefined, "[NICKCHANGE]");

        this.stropheConnection.send(m.tree());

        var p: any = {
            to: "room" + chatId + XmppSessionTypes.localhost,
            newNickName: visitorName,
        };
        var t = $msg(p);
        t.c("body", undefined, "ChangeNickNameRequest");

        this.stropheConnection.send(t.tree());
    }
    sendGreeterMsgAsQC(msg: string, chatId: string, websiteId: Number, visitorName: string, chat?: ChatModel) {
        var userData = this.GetUserLoginData()!;

        var o: XmppPacket = {
            to: "room" + chatId + XmppSessionTypes.localhost,
            type: "groupchat",
            chat_id: chatId,
            custom_packet: true.toString(),
            user_id: "-" + userData.userId.toString(),
            manager_id: userData.userId.toString(),
            time_stamp: moment().format("YYYY-MM-DD HH:mm:ss"),
            website_id: websiteId.toString(),
            visitor_name: visitorName,
            message: "",
            messageType: MessageType.QCGreeting?.toString(),
        };
        var m = $msg(o as any);
        m.c("body", undefined, msg);

        this.stropheConnection.send(m.tree());
    }

    sendInitVideoMsg = (msg: string, chat?: ChatModel) => {
        if (chat) {
            var userData = this.GetUserLoginData()!;
            var o: XmppPacket = {
                to: "room" + chat?.info?.chatId + XmppSessionTypes.localhost,
                type: "groupchat",
                chat_id: chat?.info?.chatId,
                custom_packet: true.toString(),
                user_id: "-" + userData.userId.toString(),
                manager_id: userData.userId.toString(),
                time_stamp: moment().format("YYYY-MM-DD HH:mm:ss"),
                website_id: chat?.info?.websiteId.toString(),
                visitor_name: chat?.info?.visitorName,
                message: "",
                messageType: MessageType.QCGreeting?.toString(),
            };
            var m = $msg(o as any);
            m.c("body", undefined, msg);

            this.stropheConnection.send(m.tree());
        }
    };

    buzzQC = (buzzType: string, chat: ChatModel, message: string) => {
        var userData = this.GetUserLoginData()!;
        if (buzzType === "BuzzQC") {
            this.stropheConnection.send(
                $msg({
                    to: chat.roomId,
                    chat_id: chat.info.chatId,
                    custom_packet: false.toString(),
                    user_id: (userData.userId * -1).toString(),
                    message: message,
                    manager_id: userData.userId.toString(),
                    time_stamp: moment().format("YYYY-MM-DD HH:mm:ss"),
                    visitor_name: userData.username,
                    website_id: chat?.info?.websiteId,
                    type: "groupchat",
                    messageType: MessageType.BuzzChat?.toString(),
                }).c("active", {
                    xmlns: "http://jabber.org/protocol/chatstates",
                })
            );

            // var o = {
            //   to: chat.roomId,
            //   type: "groupchat",
            //   chat_id: chat.info.chatId,
            //   user_id: userData.userId * -1,
            //   manager_id: userData.userId,
            //   typing_time: "0",
            //   // time_stamp: "0",
            //   end_time: false,
            //   visitor_name: userData.username,
            //   custom_packet: true,
            //   website_id: chat?.info?.websiteId,
            // };

            // var m = $msg(o as any);
            // m.c("body", null, "");
            // this.stropheConnection.send(m.tree());
            this.newOutGoingBuzzMessage(chat, message, userData);
        } else {
            this.newOutGoingBuzzMessage(chat, message, userData);
        }
    };

    sendPresence = (status: XmppChatStatus) => {
        if (!this.isConnected()) {
            return;
        }

        var presenceObject = this.buildPresenceObject(status);
        if (DetectEnvironment.config.REACT_APP_IS_FIREBASE_ENABLE) {
            this.stropheConnection.send(presenceObject);
        }
    };

    buildPresenceObject = (status: XmppChatStatus, attributes?: any): Strophe.Builder => {
        var obj: Strophe.Builder = $pres(attributes);
        // var firebaseToken = this.firebaseToken;       

        var token = this.firebaseToken;
        if (utils.isElectronBuild()) {
            token = localStorage.getItem("fireBaseToken") as any;
            if (token != null && token != "undefined") {
                token = token;
            }
        }

        var AppName = DetectEnvironment.config.REACT_APP_NAME
        if (utils.detectMobileDevice()) {
            AppName = "WG Live Chat Android"
            token = cookieService.getElectronCookies("firebase_token");
        }

        var userData = this.GetUserLoginData();
        var xmppStatus = XmppChatStatus[status].toLowerCase();
        var statusString = `${xmppStatus}|${token}|${userData?.username}|${userData?.userLog}|${userData?.empCompId}|${AppName}|Web`;

        obj.c("status", undefined, statusString);

        return obj;
    };

    newOutGoingBuzzMessage = (chat: ChatModel, message: string, userData: any) => {
        var o: XmppPacket = {
            to: chat.roomId,
            message: message,
            type: "groupchat",
            chat_id: chat.info.chatId,
            custom_packet: true.toString(),
            end_time: false,
            time_stamp: moment().format("YYYY-MM-DD HH:mm:ss"),
            user_id: (userData.userId * -1).toString(),
            visitor_name: userData.username,
            manager_id: userData.userId.toString(),
        } as any;

        var m = $msg(o as any);
        m.c("body", undefined, message);

        this.stropheConnection.send(m.tree());
    };
}

function onAppVisibilityChange() {
    var state = document.visibilityState == "visible" ? XmppChatStatus.Online : XmppChatStatus.Away;
    // logger.log("AppState: " + XmppChatStatus[state].toLowerCase()); // commented for temporary
    xmppChatService.sendPresence(state);
}

document.addEventListener("visibilitychange", onAppVisibilityChange);

var xmppChatService = new XmppChatService();
export { xmppChatService };
